module.exports = "/_next/static/resources/photo-1-d30516fbd4a928256a159a9b1dfe8e7c.jpg";